import { render, staticRenderFns } from "./lookupCom.vue?vue&type=template&id=0045f45a&"
import script from "./lookupCom.vue?vue&type=script&lang=js&"
export * from "./lookupCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports